/**
 * Triangles rectangles aux coins du panneau bleu, angle droit sur le coin.
 * Grand côté (hypoténuse) incurvé vers l’intérieur du triangle (ventre concave).
 */
export function AuthPanelCornerDecor() {
  /* Côtés droits : le long (haut / bas du panneau) est allongé ; hauteur du petit côté inchangée */
  const size = "h-[88px] w-[min(98vw,800px)]";
  const svgClass = `pointer-events-none absolute z-0 ${size} drop-shadow-lg`;

  /* Rouge : M 0 0 → haut, courbe Q (ventre vers le coin), fermeture */
  const pathRed = "M 0 0 L 100 0 Q 32 32 0 100 Z";
  /* Jaune : angle bas-droite ; hypoténuse courbe vers l’intérieur */
  const pathYellow = "M 100 100 L 0 100 Q 68 68 100 0 Z";

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden hidden lg:block" aria-hidden>
      <svg
        className={`${svgClass} left-0 top-0`}
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <path fill="#f7040a" d={pathRed} />
      </svg>
      <svg
        className={`${svgClass} bottom-0 right-0`}
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <path fill="#F2B531" d={pathYellow} />
      </svg>
    </div>
  );
}
